import * as types from '../mutation-types'
import ledgeraccService from '../../services/ledgeraccs'

const state = {
  loading: false,
  errors: null,
  ledgeraccs: [],
  inc_ledgeraccs: [],
  exp_ledgeraccs: []
}

const actions = {
  getAll({ commit }) {
    commit(types.LEDGERACC_LOADING, true)
    ledgeraccService.getAll().then(
      response => {

        commit(types.LOAD_LEDGERACCS, response.data)
        commit(types.LEDGERACC_LOADING, false)
        commit(types.LEDGERACC_FAILURE, null)
      },
      error => {
        commit(types.LEDGERACC_FAILURE, error)
        commit(types.LEDGERACC_LOADING, false)
      }
    )
  },
  add({ commit }, data) {
    commit(types.LEDGERACC_LOADING, true)
    commit(types.LEDGERACC_FAILURE, null)

    ledgeraccService.add(data).then(
      response => {
        data.id = response.data.id
        commit(types.ADD_LEDGERACC, data)
        commit(types.LEDGERACC_LOADING, false)

      },
      error => {
        commit(types.LEDGERACC_FAILURE, error)
        commit(types.LEDGERACC_LOADING, false)
      }
    )
  },
  update({ commit }, data) {
    commit(types.LEDGERACC_LOADING, true)
    commit(types.LEDGERACC_FAILURE, null)
    //data.ledgeracc.roles = ["ledgeracc"]
    ledgeraccService.update(data.ledgeracc)
      .then(
        response => {
          commit(types.UPDATE_LEDGERACC, data)
          commit(types.LEDGERACC_LOADING, false)

        },
        error => {
          commit(types.LEDGERACC_FAILURE, error)
          commit(types.LEDGERACC_LOADING, false)
        }
      )


  },
  delete({ commit }, data) {
    commit(types.LEDGERACC_LOADING, true)
    commit(types.LEDGERACC_FAILURE, null)
    ledgeraccService.delete(data.ledgeracc.id)
      .then(
        response => {

          commit(types.DELETE_LEDGERACC, data)
          commit(types.LEDGERACC_LOADING, false)

        },
        error => {
          commit(types.LEDGERACC_FAILURE, error)
          commit(types.LEDGERACC_LOADING, false)
        }
      )
  }
}

const mutations = {
  [types.ADD_LEDGERACC](state, payload) {
    state.ledgeraccs.unshift(payload);
  },
  [types.LOAD_LEDGERACCS](state, payload) {
    state.ledgeraccs = payload

    state.inc_ledgeraccs = state.ledgeraccs ? state.ledgeraccs.filter(l => l.type == "income") : []

    state.exp_ledgeraccs = state.ledgeraccs ? state.ledgeraccs.filter(l => l.type == "expense") : []


  },
  [types.UPDATE_LEDGERACC](state, payload) {
    Object.assign(state.ledgeraccs[payload.index], payload.ledgeracc);
  },
  [types.DELETE_LEDGERACC](state, payload) {
    state.ledgeraccs.splice(payload.index, 1)
  },
  [types.LEDGERACC_FAILURE](state, payload) {
    state.errors = payload
  },

  [types.LEDGERACC_LOADING](state, payload) {
    state.loading = payload
  },
}


const getters = {
  LEDGERACCS: state => {
    return state.ledgeraccs
  },
  INCLEDGERACCS: state => {
    return state.inc_ledgeraccs
  },

  EXPLEDGERACCS: state => {
    return state.exp_ledgeraccs
  },

  LEDGERACC_ERROR: state => {
    return state.errors
  },

  LEDGERACC_LOADING: state => {
    return state.loading
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/ledgeraccs.js